import { render, staticRenderFns } from "./CatalogDetails.vue?vue&type=template&id=c8297262&scoped=true&"
import script from "./CatalogDetails.vue?vue&type=script&lang=js&"
export * from "./CatalogDetails.vue?vue&type=script&lang=js&"
import style0 from "./CatalogDetails.vue?vue&type=style&index=0&id=c8297262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8297262",
  null
  
)

export default component.exports